import {
  annotationsReducer,
  applicationReducer,
  appModulesReducer,
  appStatesReducer,
  authReducer,
  bookmarksReducer,
  booksReducer,
  cloudsReducer,
  commentsReducer,
  homeSettingsReducer,
  institutionsReducer,
  jobsReducer,
  licencesReducer,
  logsReducer,
  pdfReducer,
  publishersReducer,
  readerReducer,
  reportReducer,
  resellersReducer,
  searchReducer,
  tagsReducer,
  textSelectionReducer,
  transactionsReducer,
  usersReducer,
  cloudsAndContentReducer,
} from '@readcloud/state';
import { combineReducers } from '@reduxjs/toolkit';

const combinedReducer = combineReducers({
  AnnotationsState: annotationsReducer,
  AppModulesState: appModulesReducer,
  AppStatesState: appStatesReducer,
  AuthState: authReducer,
  BookmarksState: bookmarksReducer,
  BooksState: booksReducer,
  CloudsState: cloudsReducer,
  CommentsState: commentsReducer,
  InstitutionsState: institutionsReducer,
  LicencesState: licencesReducer,
  LogsState: logsReducer,
  PublishersState: publishersReducer,
  ResellersState: resellersReducer,
  TagsState: tagsReducer,
  TransactionsState: transactionsReducer,
  UserState: usersReducer,
  ReaderState: readerReducer,
  ApplicationState: applicationReducer,
  PDFState: pdfReducer,
  ReportState: reportReducer,
  SearchState: searchReducer,
  TextSelectionState: textSelectionReducer,
  JobsState: jobsReducer,
  HomeSettingsState: homeSettingsReducer,
  CloudsAndContentState: cloudsAndContentReducer,
});

// Root reducer that resets all state on logout, preventing stale data
// from the previous user leaking into the next session.
// We preserve PDFState, HomeSettingsState, and SearchState since they
// are user-preference UI settings (also the redux-persist whitelist).
const RootReducerCombined: typeof combinedReducer = (state, action) => {
  if (action.type === 'auth/logout/pending') {
    // Reset all state to initial values except UI preferences
    const preserved = state
      ? {
          PDFState: state.PDFState,
          HomeSettingsState: state.HomeSettingsState,
          SearchState: state.SearchState,
        }
      : {};
    return combinedReducer({ ...preserved } as any, action);
  }
  return combinedReducer(state, action);
};

export type AppState = ReturnType<typeof combinedReducer>;

export default RootReducerCombined;
